"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function polis(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M19.2382 18.0041V17.2541C19.2382 17.1056 19.1385 17.0066 18.987 17.0066H18.4882V16.2536C18.4882 16.1043 18.3885 16.0031 18.24 16.0031H17.7405V10.4943H18.237C18.3862 10.4943 18.4882 10.3953 18.4882 10.2438V9.4938H18.987C19.0457 9.49627 19.1034 9.47721 19.1491 9.44021C19.1948 9.4032 19.2254 9.35079 19.2352 9.2928C19.2607 9.1683 19.2105 9.0693 19.1115 9.0168L12.123 5.5128C12.0505 5.488 11.9719 5.488 11.8995 5.5128L4.66048 9.0168C4.61295 9.04268 4.57512 9.08329 4.55266 9.13252C4.53021 9.18176 4.52436 9.23695 4.53598 9.2898C4.53598 9.4173 4.63573 9.4938 4.75948 9.4938H5.50948V10.2438C5.50948 10.3923 5.60923 10.4913 5.75773 10.4913H6.25723V16.0031H5.76073C5.61073 16.0031 5.50948 16.1021 5.50948 16.2506V17.0036H5.01073C4.86073 17.0036 4.76173 17.1026 4.76173 17.2518V18.0041C4.61323 18.0041 4.51123 18.1038 4.51123 18.2553C4.51123 18.4068 4.61023 18.5058 4.75948 18.5058H19.2382C19.3867 18.5058 19.4887 18.4068 19.4887 18.2583C19.4887 18.1083 19.3897 18.0041 19.2412 18.0041H19.2382ZM6.00598 9.99255V9.4938H17.9865V9.99255H6.00598ZM16.2382 10.4951V16.0031H15.2422V10.4943H16.2382V10.4951ZM13.7422 10.4951V16.0031H12.744V10.4943H13.7415L13.7422 10.4951ZM11.2462 10.4951V16.0031H10.2502V10.4943H11.2462V10.4951ZM8.75023 10.4951V16.0031H7.75498V10.4943H8.75023V10.4951ZM17.9865 17.0036H6.00898V16.5018H17.9887V17.0036H17.9865Z", fill: color }));
}
exports["default"] = polis;
//# sourceMappingURL=polis.js.map